import { getField } from "vuex-map-fields";

const familyArray = (state) => {
  if (state.family === null) return [];
  let customersArray = [];
  if ("main" in state.family) {
    customersArray.push(state.family.main.data);
  }
  if ("partner" in state.family) {
    customersArray.push(state.family.partner.data);
  }
  if ("children" in state.family) {
    customersArray = [...customersArray, ...state.family.children.data];
  }
  return customersArray;
};
const familyOptions = (state, getters) => getters.familyArray.map((customer) => ({
  label: customer.full_name,
  value: customer.id,
}));
export default {
  familyOptions,
  familyArray,
  getField,
};
